import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShoppingBagIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shopping_bag"}/>
}
